<template>
    <div>
        <AuthPopup
            v-if="showAuthPopup"
            :webview-redirect-to="createWebviewRedirectTo()"
            :show-close-button="false"
            @login-success="loginSuccess"
            @register-success="loginSuccess" />

        <share-modal v-if="showShareModal" @close="showShareModal = false"
            @copied="copyLink($event, 'link')"
            :is-front-page="true"
            :sub-title="$t('playalone_share_quiz_modal_not_support_puzzle')"
            :quiz-id="quiz._id" v-model="quiz.url" />
    </div>
</template>

<script>

import UserService from '@/lib/user'
import AuthPopup from '@/components/AuthPopup'
import AuthPopupMixin from '@/mixins/auth-popup'
import popup from '@/lib/popup.js'
import helper from '@/lib/helper.js'
import { currentUser, isLoggedIn } from '@/lib/user'
import { mapState } from 'vuex'
import ShareModal from '@/components/PlayAloneShareModal.vue'

export default {

    mixins: [AuthPopupMixin],

    components: {
        AuthPopup,
        ShareModal
    },

    data () {
        return {
            showShareModal: false,
        }
    },

    computed: {
        ...mapState({
            quizId: state => state.player.quiz._id.$oid,
            quiz: state => state.player.quiz,
            embedToken: state => state.player.embedToken
        })
    },

    mounted: function() {

        const userService = new UserService

        userService.validateToken().then(() => {
            this.afterLoginSuccess()
        })
        .catch(() => {
            this.showAuthPopup = true
        })
    },

    methods: {
        afterLoginSuccess () {

            this.$store.commit('updateIsActiveOnly', true)

            let params = { id :this.$route.params.id}
            if (helper.isMessengerWebview()){
                params =  {
                    id :this.$route.params.id,
                    webview : 1
                }
            }
            this.$store.dispatch('fetchQuestionAndRandomById', params)
                .then((res) => {
                    const quiz = res.data.data

                    const mode = new URL(window.location.href).searchParams.get('mode');

                    if (mode && mode == 'preview') {
                        quiz.inactive_quiz = false
                    }

                    if (quiz.inactive_quiz) {
                        window.location.href = '/'
                        return
                    }

                    if (this.$route.query.type == 'pt') {
                        this.$store.commit('player/updateQuiz', quiz)
                        this.$store.commit('player/setIsMasterPlayer', true)
                        this.$store.commit('player/isPlayTogether', true)
                    }

                    if (quiz.is_puzzle_empty) {
                        this.showShareModal = true
                         return
                    }

                    this.$socket.emit('master_prepare_quiz', {
                        id: this.$route.params.id
                    })


                    quiz.playing_type = this.$route.query.type == 'pt' ? 'play_together' : ''
                    quiz.master_player_name = 'Master'
                    quiz.master_user_id = ''
                    quiz.is_playing = 'not_start'
                    quiz.is_play_song_master = true

                    if (isLoggedIn()) {
                        quiz.master_player_name = helper.shortName(currentUser().name)
                        quiz.master_user_id = currentUser().id
                    }

                    this.$socket.emit('master_update_quiz', {
                        quiz: quiz
                    })

                    if (this.$route.params.slug == 'create' || this.$route.params.slug == 'update') {
                        this.$store.commit('resetQuiz')
                        this.$router.replace({
                            name: 'my-quiz',
                            query: {
                                "quiz-oid": this.$route.params.id,
                                type: this.$route.query.type
                            }
                        })
                    } else {
                        this.$router.replace({
                            name: 'start-quiz',
                            query: {
                                id: this.$route.params.id,
                                type: this.$route.query.type
                            }
                        })
                    }
                    this.$store.commit('updateIsActiveOnly', false)
                })
                .catch((err) => {
                    if (err.response.status) {
                        return popup.alert('You dont have permission to access this quiz', () => {
                            window.location.href = '/'
                        })
                    }
                })
        },

        copyLink(url, type) {
            url = url || window.shareLink

            if (window.navigator.share) {
                navigator.share({
                    title: 'TheBigQuiz',
                    text: 'TheBigQuiz',
                    url: url
                })
            } else {
                navigator.clipboard.writeText(url)
                    .then(() => {
                        if (type != 'embed') {
                            popup.alert(this.$t('landing_alert_link_copied'), true, { icon: 'success' })
                        } else {
                            popup.alert(this.$t('embed_modal_alert_copied'), true, { icon: 'success' })
                        }
                    })
                    .catch(() => {
                        if (type != 'embed') {
                            popup.alert(this.$t('landing_alert_link_copied_error'), true, { icon: 'error' })
                        } else {
                            popup.alert(this.$t('embed_modal_alert_copied_error'), true, { icon: 'error' })
                        }
                    })
            }
        },
    }
}
</script>
